import { render, staticRenderFns } from "./operatorMeal.vue?vue&type=template&id=06d62eb7&"
import script from "./operatorMeal.vue?vue&type=script&lang=js&"
export * from "./operatorMeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports